import { TooltipProps, Tooltip } from "antd";

export const CommonTooltip = (props: TooltipProps) => (
  <Tooltip mouseEnterDelay={0.5} {...props} />
);